import { v4 as uuidv4 } from 'uuid';

export const ADD_REQUEST = 'ADD_REQUEST';
export const UPDATE_REQUEST = 'UPDATE_REQUEST';
export const DELETE_REQUEST = 'DELETE_REQUEST';

export const addRequest = (request) => ({
  type: ADD_REQUEST,
  payload: { id: uuidv4(), ...request },
});

export const updateRequest = (id, request) => ({
  type: UPDATE_REQUEST,
  payload: { id, ...request },
});

export const deleteRequest = (id) => ({
  type: DELETE_REQUEST,
  payload: id,
});
